export const APP_LAUNCHER_MANIFEST_PATH = "/app-launcher-manifest.json";

export type AppLauncherManifestEntry = {
  name: string;
  icon: string;
  link: string;
};

function isManifestEntry(value: unknown): value is AppLauncherManifestEntry {
  if (!value || typeof value !== "object") return false;
  const entry = value as Record<string, unknown>;

  return (
    typeof entry.name === "string" &&
    entry.name.trim().length > 0 &&
    typeof entry.icon === "string" &&
    entry.icon.trim().length > 0 &&
    typeof entry.link === "string" &&
    entry.link.trim().length > 0
  );
}

export function parseAppLauncherManifest(
  value: unknown,
): readonly AppLauncherManifestEntry[] {
  if (!Array.isArray(value) || value.length === 0) return [];
  return value.every(isManifestEntry) ? value : [];
}

export type LoadAppLauncherManifestOptions = {
  authAppUrl: string;
  fetcher?: typeof fetch;
};

export function resolveAppLauncherManifestUrl(
  authAppUrl: string,
): string {
  return new URL(
    APP_LAUNCHER_MANIFEST_PATH,
    `${new URL(authAppUrl).origin}/`,
  ).href;
}

export async function loadAppLauncherManifest({
  authAppUrl,
  fetcher = fetch,
}: LoadAppLauncherManifestOptions): Promise<
  readonly AppLauncherManifestEntry[]
> {
  const response = await fetcher(
    resolveAppLauncherManifestUrl(authAppUrl),
    {
      cache: "no-store",
      headers: { Accept: "application/json" },
    },
  );
  if (!response.ok) return [];

  return parseAppLauncherManifest(await response.json());
}

export function isCurrentAppLink(link: string, currentUrl: string): boolean {
  try {
    return new URL(link, currentUrl).origin === new URL(currentUrl).origin;
  } catch {
    return false;
  }
}
